/**
 * Created by RKL on 07/09/2015.
 */
define('adminLmbAnalyzerDetailsController',[
  'module',
  'underscore',
  'app',
  'bootbox',
  'adminLmbAnalyzerDetailsView',
  'emptyView',
  'lmbAnalyzerDetailTabController',
  'rolesMixin',
  'settings',
  'entities/lmbanalyzers'
], function(
  module,
  _,
  App,
  bootbox,
  View,
  EmptyView,
  lmbAnalyzerDetailTabController
) {
  'use strict';

  var LmbAnalyzersDetailsController = {
    fetchLmbAnalyzer: function(data) {
      var that = this,
          emptyView = new EmptyView(),
          contentRegion = App.regions.getRegion('main').currentView.getRegion('content');

      contentRegion.show(emptyView);

      this.data = data;
      if (this.model && this.model.get('secId') === data.secId) {
        this.showLmbAnalyzer(data);
      } else {
        this.model = App.request('lmbanalyzer:model', {secId: data.secId});
        this.model.fetch().done(function() {
          if (contentRegion) {
            that.showLmbAnalyzer(data);
          }
        });
      }
    },

    showLmbAnalyzer: function(data) {
      var view = new View({model: this.model, data: data});

      this.view = view;
      data.model = this.model;

      App.regions.getRegion('main').currentView.getRegion('content').show(view);

      this.displayTabs(data);

      view.listenTo(view, 'click:tab', _.bind(this.onTabClick, this));
      view.listenTo(App, 'lmbanalyzer:header:rerender', _.bind(this.onHeaderChange, this));
    },

    onHeaderChange: function (lmbAnalyzer) {
      this.view.onHeaderChange(lmbAnalyzer);
    },

    displayTabs: function(data) {
      for (var region in this.view.regions) {
        if (App.regions.getRegion('main') && App.regions.getRegion('main').currentView &&
            App.regions.getRegion('main').currentView.getRegion('content') &&
            App.regions.getRegion('main').currentView.getRegion('content').currentView &&
            App.regions.getRegion('main').currentView.getRegion('content').currentView.getRegion(region)) {
          var currentViewRegion = App.regions.getRegion('main').currentView.getRegion('content').currentView.getRegion(region).currentView;
          if(currentViewRegion) {
            currentViewRegion.destroy();
          }
        }
      }

      lmbAnalyzerDetailTabController.showTab(data);

      data.model = this.model;
      this.tab = data.tab;
    },

    onTabClick: function(tab) {
      if (this.data.tab !== tab || this.data.secId) {
        this.data.tab = tab;
        this.data.secId = null;

        this.displayTabs(this.data);
        App.navigate('admin/lmbanalyzers/' + this.model.get('secId') + '/' + tab.name);
      }
    }
  };

  module.exports = LmbAnalyzersDetailsController;
});
